import styled from "styled-components";
//import playIcon from "../../../images/video-play-icon.svg";

export const AccountImg=styled.img`
@media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
and (-webkit-min-device-pixel-ratio: 1) {
    top:-9px;
    position:relative;
}
`;
export const PCVideoTitle=styled.div`
 font-size: 34px;
 font-family: "Lato-Bold";
    line-height: 80%;
    text-align: center; 
`;
export const PCVideoText=styled.div`
    font-size: 16px;
    line-height: 150%;
    padding: 5px 30px;
`;
export const PCVideoTextBold=styled.div`
    font-size: 16px;
    font-family: "Lato-Bold";
    line-height: 150%;
    padding: 10px 30px;
`
export const PCVideoPlayButton = styled.img`
    position: absolute;
    width: 8vh;
    height: 8vh;
    top: ${props=>props?.mediagallery?"57%":"50%"};
    left: 50%;
    transform: translate(-50%, -50%);
    background-repeat: no-repeat;
    cursor:pointer;
    @media screen and (max-width: 820px){
        top: ${props=>props?.mediagallery?"33%":"50%"};
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
export const LetterImg = styled.img`
     width: 100%;
    height: 30vh;
    object-fit: cover;
    object-position: 10% 10%;
    border-radius: 10px;
    @media screen and (max-width: 750px){
        height: 25vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
        height: 14vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: landscape) 
    and (-webkit-min-device-pixel-ratio: 1) {
        height: 25vh;
    }
`;
export const LetterImgError = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30vh;
    background-color: #f2f2f2;
    border-radius: 10px;
    & img{
        width: 48px;
    }
    @media screen and (max-width: 750px){
        height: 25vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
        height: 14vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: landscape) 
    and (-webkit-min-device-pixel-ratio: 1) {
        height: 25vh;
    }
`
export const LetterVideoError = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
    background-color: #fff;
    border-radius: 10px;
    & img{
        width: 48px;
    }
`
export const LetterTitle = styled.div`
    font-family: "Lato-Bold";
    font-size: 24px;
    line-height: 120%;
    padding: 10px 0;
    @media screen and (max-width: 750px){
        padding:1rem 0;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 20px;
        line-height: 120%;
        padding: 1rem 0px;
        font-weight: 700;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: landscape) 
    and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 20px;
        line-height: 120%;
        padding: 1rem 0px;
        font-weight: 700;
    }
`;
export const LetterBody = styled.div`
     font-size: 14px;
     @media screen and (max-width: 750px){
        color: #000;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0%;
    }
`;
export const PCBack = styled.div`
    position: absolute;
    top: 15px;
    left: 20px;
    color: #fff;
    cursor: pointer;
    z-index: 2;
    & span{
     margin-left: 10px;
    }
    @media only screen and (max-width: 750px){
        position:relative;
        top: 10px;
        left: 10px;
    }
    @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
        top: 1.25rem;
        left: 2rem;
    }
`;
export const MenuIconContainer = styled.div`
    @media only screen and (max-width: 750px){
        position:absolute;
        top: 10px;
        right: 10px;
    }
`;
export const FloatingDiv = styled.div`
     border-radius: 5px;
    width: 90px;
    border: 7px solid #F66700;
    // top: 0;
    // right: -10px;
    // position: absolute;
    top: 47%;
    right: 20px;
    position: fixed;
    z-index: 1000;
    background-color: #f66700;
    cursor: pointer;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
        z-index:9;
        top: 12px;
        right: 12px;
    }
    @media only screen and (min-device-width: 1400px) {
        top: 37%;
    }
`;



